import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import logoInteagro from "../../assets/img/logo-inteagro.png";
import styles from "./Login.module.css";

/**
 * AcessoRapido — Rota: /acesso/:token
 * 
 * O produtor clica no link do WhatsApp e cai aqui.
 * Esta tela valida o token, salva o JWT e redireciona para o dashboard.
 * Nenhuma senha é necessária.
 */
const AcessoRapido = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'validando' | 'erro' | 'expirado'>('validando');
  const [mensagemErro, setMensagemErro] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('erro');
      setMensagemErro('Link inválido.');
      return;
    }

    api.get(`/auth/acesso-rapido/${token}`)
      .then(res => {
        const { token: jwt, user } = res.data.data;

        localStorage.setItem("inteagro_token", jwt);
        localStorage.setItem("nome", user.nome);
        localStorage.setItem("role", user.perfil || "agro");
        localStorage.setItem("modulo", user.modulo || "agro");
        localStorage.setItem("uid_unidade_producao", user.uid_unidade_producao || "");
        localStorage.setItem("uid_estabelecimento", user.uid_estabelecimento || "");
        localStorage.setItem("uid_projeto", user.uid_projeto || "");

        // Redireciona para o módulo correto
        if (user.modulo === "pesca") {
          navigate('/admin/dashboard', { replace: true });
        } else {
          navigate('/agro/dashboard', { replace: true });
        }
      })
      .catch(err => {
        const status = err.response?.status;
        if (status === 410) {
          setStatus('expirado');
          setMensagemErro('Este link expirou. Envie "oi" no WhatsApp para receber um novo link.');
        } else {
          setStatus('erro');
          setMensagemErro('Link inválido ou já utilizado.');
        }
      });
  }, [token, navigate]);

  return (
    <div className={styles.main}>
      <div className={`${styles.contentLeftSide} desktop`}>
        <h1 className={styles.title}>
          <span className={styles.textGradientAnimated}>Inteagro</span>{" "}
          Conectando o campo ao futuro.
        </h1>
      </div>

      <div className={styles.containerLogin}>
        <div className={styles.login}>
          <div className={styles.loginHead}>
            <img src={logoInteagro} alt="Inteagro" className={styles.logoLogin} />
          </div>

          {status === 'validando' && (
            <div style={{ textAlign: 'center', padding: '30px 0' }}>
              <div style={{
                width: 40, height: 40, border: '4px solid #e0e0e0',
                borderTop: '4px solid #00b37e', borderRadius: '50%',
                animation: 'spin 0.8s linear infinite', margin: '0 auto 16px',
              }} />
              <p style={{ color: '#666' }}>Acessando sua fazenda...</p>
            </div>
          )}

          {(status === 'erro' || status === 'expirado') && (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{
                fontSize: '3rem', marginBottom: 16,
              }}>
                {status === 'expirado' ? '⏰' : '❌'}
              </div>
              <p style={{ color: '#333', fontWeight: 600, marginBottom: 8 }}>
                {status === 'expirado' ? 'Link expirado' : 'Link inválido'}
              </p>
              <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: 24 }}>
                {mensagemErro}
              </p>
              <button
                onClick={() => navigate('/')}
                style={{
                  background: '#00b37e', color: '#fff', border: 'none',
                  padding: '10px 24px', borderRadius: 8, cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                Ir para o login
              </button>
            </div>
          )}
        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default AcessoRapido;